import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RuleForm from '../inputs/RuleForm';
import InlineInputNumber from '../inputs/InlineInputNumber';
import InlineManufacturerSelect from '../inputs/InlineManufacturerSelect';
import InlineSupplierSelect from '../inputs/InlineSupplierSelect';
import InlineRegionSelect from '../inputs/InlineRegionSelect';


class EffectiveSupplierPriceGuidance extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onReset = this.onReset.bind(this);
    const { initialValues } = props;
    this.initialState = {
      percent: initialValues.percent || 0.25,
      supplier: initialValues.supplier || 1,
      exclude_manufacturer_ids: initialValues.exclude_manufacturer_ids || [],
      regions: initialValues.regions && initialValues.regions.length > 0 ? initialValues.regions : [0]
    };

    this.state = this.initialState;
  }

  onSubmit(event) {
    event.preventDefault();
    const {
      percent, supplier, exclude_manufacturer_ids, regions
    } = this.state;
    const manufacturer_id_list = _.map(exclude_manufacturer_ids, id_ => parseInt(id_, 10));
    this.props.onSubmit({
      kind: 'effective_supplier_price',
      regions: _.filter(regions),
      value: {
        percent: parseFloat(percent),
        supplier: parseFloat(supplier),
        exclude_manufacturer_ids: manufacturer_id_list
      }
    });
  }

  onReset() {
    this.setState(this.initialState);
  }

  render() {
    const { regions } = this.state;
    const { form, type, ...other } = this.props;

    return (
      <RuleForm
        {...other}
        onSubmit={this.onSubmit}
        onReset={this.onReset}
        isSubmitting={form.is_submitting}
      >
        <InlineRegionSelect
          onChange={val => this.setState({ regions: val })}
          value={regions}
        />
        <InlineSupplierSelect
          value={this.state.supplier}
          onChange={supplier => this.setState({ supplier })}
          include_all={false}
          include_any={false}
        />
        <InlineManufacturerSelect
          clearable={true}
          value={this.state.exclude_manufacturer_ids}
          label='Excluded Manufacturers'
          description='Manufacturers to not include'
          placeholder='Excluded Manufacturers'
          onChange={value => this.setState({ exclude_manufacturer_ids: value })}
        />
        <InlineInputNumber
          label='Discount Percentage'
          description='Amount to discount off of each item'
          displayFormat='percent'
          value={this.state.percent}
          onChange={value => this.setState({ percent: value })}
        />
      </RuleForm>
    );
  }
}

EffectiveSupplierPriceGuidance.defaultProps = {
  type: 'add',
  initialValues: {}
};

EffectiveSupplierPriceGuidance.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  type: PropTypes.string,
  initialValues: PropTypes.object,
};

export default EffectiveSupplierPriceGuidance;
